import React from "react";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import BilateralLoanData from "../../../../components/bilateralLoanData";
import BilateralAssignedCollateral from "../../../../components/bilateralAssignedCollateral";
import LoadingOverlay from 'react-loading-overlay';
import PropTypes from "prop-types";

const BilateralMarginCall = ({...props}) => {
    return (
        <LoadingOverlay
            active={props.isLoading}
            spinner
            text='Loading...'>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TitlePage title="Bilaterales \ Tablero de Control \ Exceso"/>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid item>
                            <Button
                                label="Guardar"
                                style={{'float': 'right'}}
                                onClick={props.saveExcess}/>
                        </Grid>
                        <Grid item>
                            <Button
                                label="Regresar"
                                style={{'float': 'right'}}
                                className="p-button-secondary"
                                onClick={props.handleReturnButton}/>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                    <BilateralLoanData
                        ref={props.bilateralLoanData}
                        selectedLoan={props.selectedLoan}
                        loading={props.loading}
                    />
                    <Grid item xs={12}>
                        <br/><Divider/>
                    </Grid>
                    <BilateralAssignedCollateral
                        ref={props.bilateralAssignedCollateral}
                        loading={props.loading}
                        collateralDetail={props.collateralDetail}
                        isExcess={true}
                    />
                </Grid>
            </Paper>
        </LoadingOverlay>
    )
};

export default BilateralMarginCall;

BilateralMarginCall.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    messagesGrowl: PropTypes.object.isRequired,
    handleReturnButton: PropTypes.func.isRequired,
    selectedLoan: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    bilateralLoanData: PropTypes.object.isRequired,
    saveExcess: PropTypes.func.isRequired,
    bilateralAssignedCollateral: PropTypes.object.isRequired,
    collateralDetail: PropTypes.object.isRequired,
};